/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { Table } from '@components/design-system';
import { UserComponent, TextComponent } from '@components/table-components';

const settings = [
  {
    key: 'collected',
    label: 'Source',
    Component: ({ collected }: Record<string, any>) => <TextComponent value={collected ? 'Purchased' : 'Received'} />,
  },
  {
    key: 'collectorScreenName',
    label: 'Collector',
    Component: ({ collectorScreenName, holder, isYou, isCreator }: Record<string, any>) => (
      <UserComponent
        {...holder.user[0].user}
        parsedScreenName={collectorScreenName}
        address={holder.address}
        isYou={isYou}
        isCreator={isCreator}
      />
    ),
  },
  {
    key: 'amount',
    label: 'Quantity',
    Component: ({ amount }: Record<string, any>) => <TextComponent value={amount} />,
  },
];

interface ITableTokenCollectors {
  data: any[];
}

export const TableTokenCollectors: FC<ITableTokenCollectors> = ({ data }) => {
  return <Table settings={settings} data={data} canSelect={false} />;
};
